import styled, { css } from "styled-components";

const Container = styled.div`
	position:relative;
  background-color: #fff;
  border-radius: 6px;
	display:flex;
  flex-direction: column;
	justify-content:space-between;
  border: 1px solid ${({ theme }) => theme.COLORS.GRAY_200};
  box-shadow: 0px 2px 8px rgba(0,0,0,0.05);
  margin-bottom: 16px;
  padding-bottom: 16px;
	cursor: pointer;
	&:hover{
		opacity:0.6;
	}
	.percent-discount{
		position: absolute;
		z-index: 10;
		top: 0px;
		right: 0px;
		height: 38px;
		width: 38px;
		background: red;
		border-radius: 50%;
		transform: translate(10px, -15px);
		align-items: center;
		justify-content: center;
		display:flex;
		p{
			color:#fff;
			font-weight:600;
		}
	}
	.image-container{
		overflow: hidden;
		border-top-right-radius: 6px;
		border-top-left-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 105px;
		img{
			width: 100%;
			min-height: 105px;
			flex:2;
		}
		.infos-container{
			flex:1;
		}
	}

	.title{
		${({ theme }) => css`
			color: ${theme.COLORS.GRAY_800};
			font-weight: ${theme.FONT_WEIGHT.BOLD};
			padding: 0px 12px;
			margin-top: 16px;
		`}
	}

	.text-validate{
		${({ theme }) => css`
			color: ${theme.COLORS.GRAY_700};
			padding: 0px 12px;
			margin-top: 16px;
			font-size: 0.7em;
	`}
	}

	.text-price-old{
		${({ theme }) => css`
			color: ${theme.COLORS.GRAY_700};
			padding: 0px 12px;
			margin-top: 16px;
			text-decoration: line-through;
  `}
	}

	.text-price-new{
		${({ theme }) => css`
			color:${theme.COLORS.GREEN};
			font-weight: ${theme.FONT_WEIGHT.BOLD};
			padding: 0px 12px;
			margin-top: 4px;
	`}
	}
`;

export default Container
